module.exports = __webpack_public_path__ + "assets/img/29_194.5bea1100.jpg";